/**
 * Created by Daniel on 1/13/2020
 * -------------------------------------
 */

import { Component, OnInit, Input } from '@angular/core';
import { TabOptions, TabItem } from '../../../../widgets/tabs/tabs.model';
import { Subscription } from 'rxjs';
import { StoreQuerierService } from '../../../../services/store-querier.service';
import { workflowSetTaskProcessorSelector, workflowSetTaskStatusSelector } from '../../../../tamalelibs/redux/reducers/workflow-task.reducer';
import { Processor, TaskStatusFilter } from '../../../../tamalelibs/models/workflow.model';

@Component({
    selector: 'task-list-item',
    templateUrl: './task-list-item.component.html',
    styleUrls: ['./task-list-item.component.scss']
})
export class TaskListItemComponent implements OnInit {
    @Input() task: any;

    showTaskStatus = false;
    showPopover = false;
    tabsOptions: TabOptions;
    tabActive = 0;

    private _destroySubscriptions: Subscription[] = [];

    constructor(private _storeQuerier: StoreQuerierService) { }

    ngOnInit() {
        this._initTabs();
        this._setControlStatus();
    }

    popoverClick(event) {
        event.stopImmediatePropagation();
        event.stopPropagation();
    }

    mouseover() {
        // update the title of tab items
        const doneTaskNum = this.task.doneTasksNum;
        const ongoingTaskNum = this.task.status === 'Done' ? 0 : this.task.allTasksRealNum - this.task.doneTasksNum;

        this.tabsOptions.tabItems.forEach(tab => {
            if (tab.displayText.includes('Ongoing')) {
                tab.displayText = 'Ongoing(' + ongoingTaskNum + ')';
            } else {
                tab.displayText = 'Done(' + doneTaskNum + ')';
            }
        });

        // set the active tab status of the tab control
        const _status = this._storeQuerier.queryBySelector(workflowSetTaskStatusSelector);
        if (_status === TaskStatusFilter.Closed) {
            this.tabsOptions.selectedIndex = 1;
            this.tabActive = 1;
        } else {
            this.tabsOptions.selectedIndex = 0;
            this.tabActive = 0;
        }
        this.showPopover = true;
    }

    mouseleave() {
        this.showPopover = false;
    }

    private _initTabs() {
        const doneTaskNum = this.task.doneTasksNum;
        const ongoingTaskNum = this.task.status === 'Done' ? 0 : this.task.allTasksRealNum - this.task.doneTasksNum;
        const ongoingTaskTabName = 'Ongoing(' + ongoingTaskNum + ')';
        const doneTaskTabName = 'Done(' + doneTaskNum + ')';

        const menuItems = [
            new TabItem(ongoingTaskTabName),
            new TabItem(doneTaskTabName),
        ];
        this.tabsOptions = new TabOptions(menuItems, 0, false);

        this._destroySubscriptions.push(
            this.tabsOptions.events$.subscribe(event => {
                if (event.type === 'TAB_CHANGED') {
                    this.tabActive = event.payload;
                }
            }),
        );
    }

    private _setControlStatus() {
        const _processor = this._storeQuerier.queryBySelector(workflowSetTaskProcessorSelector);
        let _createdByMe = false;
        if (_processor === Processor.CreatedByMe) {
            _createdByMe = true;
        } else {
            _createdByMe = false;
        }

        const _closed = this._storeQuerier.queryBySelector(workflowSetTaskStatusSelector);
        let _isClosed = false;
        if (_closed === TaskStatusFilter.Closed) {
            _isClosed = true;
        } else {
            _isClosed = false;
        }
        if (_createdByMe && !_closed) {
            this.showTaskStatus = false;
        } else {
            this.showTaskStatus = true;
        }
    }
}
